"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const backgroundRef = useRef<HTMLDivElement>(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (!backgroundRef.current) return;
      const rect = backgroundRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const progress = Math.max(0, Math.min(1, (viewportHeight - rect.top) / viewportHeight));
      setScrollProgress(progress);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const scale = 1 + scrollProgress * 0.02;
  return <section className="relative w-full h-screen overflow-hidden bg-dark-background">
      <div ref={backgroundRef} className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-out" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1522495/img/hero_real_estate_skyline.png)",
      transform: `scale(${scale})`
    }}>
        <div className="absolute inset-0 bg-gradient-to-b from-dark-background/60 via-dark-background/40 to-dark-background/70" />
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full px-6 text-center">
        <div ref={contentRef} className={`max-w-4xl space-y-6 transition-all duration-[250ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-dark leading-tight">
            Your Unfair Advantage in Nigerian Real Estate
          </h1>

          <p className="text-lg md:text-xl lg:text-2xl text-foreground-dark/90 max-w-2xl mx-auto">
            Combining property acquisition expertise with cutting-edge SEO and
            digital visibility strategies to deliver unmatched results.
          </p>

          <div className="pt-4">
            <Link to="/ContactPage">
              <Button size="lg" className="btn-primary text-base md:text-lg px-8 py-4 h-auto shadow-strong hover:scale-105 active:scale-100 transition-transform duration-[150ms] ease-[cubic-bezier(0.34,1.56,0.64,1)]">
                Get Started Today
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}